import { render } from "./B2bPageAddCentre.vue?vue&type=template&id=2fdb800a&scoped=true&lang=pug"
import script from "./B2bPageAddCentre.vue?vue&type=script&lang=js"
export * from "./B2bPageAddCentre.vue?vue&type=script&lang=js"

import "./B2bPageAddCentre.vue?vue&type=style&index=0&id=2fdb800a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdb800a"]])

export default __exports__